import styled from 'styled-components';

const ConfirmButton = ({ className, child, onClick }) => {
  return (
    <>
    <Wrapper className={className} onClick={onClick}>
      <ButtonWrapper >
        <div className='btn'>
        {child}
        </div>
      </ButtonWrapper>
    </Wrapper>
    </>
  );
};
const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  width: 100%;
  z-index: 0;
  position: relative;
  max-width: 600px;
  margin: 0 auto;
`;

const ButtonWrapper = styled.button`
  width: 100%;
  background:  rgb(36 31 35) ;
  background:  linear-gradient(90deg, #ab8000 0%,  #f2ca46 100%);
  border-radius: 50px;
  padding: 5px;
  margin: 0px auto ;
  border: none;
  outline: none;
  font-size: 40px;
  display  :flex ;
  align-items: center;
  justify-content: center;
  width: 300px;
  transition: transform 0.3s ease-in-out;
  position: relative;
  cursor: pointer;
  
  
  &:hover {
    .btn-submit {
      &:before {
        opacity: 1;
      }
    }
  }
 .btn {
    letter-spacing: 1px;
    width: 100%;
    border-radius: 50px;
    background:#fff;
    color: #050B09;
    font-weight: 600;
    transition: all 0.3s ease;
    font-size: 20px;

    &:hover {
        background:  rgb(36 31 35) ;
        background:  linear-gradient(90deg, #ab8000 0%,  #f2ca46 100%)
    }
  }
  @media (max-width: 768px){
            width: auto;
        padding: 5px 5px;
    .btn { 
        max-width: 200px;
        padding: 1px 35px;
    }
  }
`;

export default ConfirmButton;
